module.exports = __webpack_public_path__ + "static/media/ig.5713caab.svg";